<template>
  <tv-page title="TV-下单" :loading="loading" :class="_.page">
    <template v-if="!loading">
      <div
        ref="goods"
        v-focusable
        v-focus-scroll="`.${_.groups}`"
        :class="_.left"
        v-on="goodsListeners"
      >
        <img src="./images/锯齿2-上.png" :class="_.bar" />

        <div :class="_.groups">
          <div
            v-for="merchant in preOrderData.orderInfo"
            :key="merchant.merchantId"
            :class="_.group"
          >
            <div :class="_.store">
              <img src="./images/店铺.png" :class="_.icon" />
              <div :class="_.name">{{ merchant.merchantName }}</div>
            </div>

            <div :class="_.list">
              <div
                v-for="goods in merchant.commodityInfo"
                :key="goods.commodityId"
                :class="_.item"
              >
                <img :src="goods.commodityPic" :class="_.cover" />
                <div :class="_.content">
                  <div :class="_.top">
                    <div :class="_.name">
                      {{ goods.commodityName }}
                    </div>
                    <div :class="_.price">￥{{ goods.unitPrice }}</div>
                  </div>
                  <div :class="_.bottom">
                    <div :class="_.spec">{{ goods.skuDesc }}</div>
                    <div :class="_.count">x{{ goods.count }}</div>
                  </div>
                </div>
              </div>
            </div>

            <div :class="_.info">
              <div :class="[_.item, _._hairlineBottom]">
                <div :class="_.label">快递</div>
                <div :class="_.value">
                  {{
                    !orderIdToPostFee[merchant.orderId]
                      ? '包邮'
                      : `￥${orderIdToPostFee[merchant.orderId]}`
                  }}
                </div>
              </div>
            </div>

            <div :class="_.total">
              共{{ merchant.totalQuantity }}件，小计
              <div :class="_.price">￥{{ merchant.totalAmount }}</div>
            </div>
          </div>
        </div>

        <div :class="_.summary">
          <div :class="_.discount">
            <div :class="_.tips">优惠金额包含优惠券满减折扣等</div>
            优惠：
            <div :class="_.price">￥{{ discountMoney }}</div>
          </div>
          <div :class="_.total">
            共 {{ totalGoods }} 件，订单合计：
            <div :class="_.price">￥{{ actualMoney }}</div>
          </div>
        </div>

        <img src="./images/锯齿2-下.png" :class="_.bar" />
      </div>

      <div :class="_.right">
        <div :class="_.title">收货地址</div>
        <x-horizontal-scroll-view ref="address" :flex="true" :class="_.address">
          <div
            v-for="item in allAddressData"
            :key="item.id"
            v-focusable
            :class="_.item"
            v-on="addressListeners"
          >
            <div :class="_.user">
              <div :class="[_.name, _._ellipsis]">{{ item.receiver }}</div>
              <div :class="_.phone">{{ item.phoneNo }}</div>
            </div>
            <div :class="[_.detail, _._ellipsis2]">
              {{
                [item.province, item.city, item.county, item.detail]
                  .filter(v => !!v)
                  .join('')
              }}
            </div>
            <div :class="_.bar" />
            <div v-if="item.id === address.id" :class="_.check" />
          </div>
          <div v-focusable :class="[_.item, _.add]" v-on="addressListeners">
            <div :class="_.icon">
              <img src="./images/加.png" :class="_.image" />
            </div>
            <div :class="_.label">添加收货地址</div>
            <div :class="_.bar" />
          </div>
        </x-horizontal-scroll-view>

        <template v-if="!is秒杀下单 && !is拼团下单">
          <div :class="_.title">可用优惠券</div>
          <x-horizontal-scroll-view
            v-if="allCouponData.length"
            ref="coupon"
            :class="_.coupon"
          >
            <div
              v-for="item in allCouponData"
              :key="item.couponId"
              v-focusable
              :class="_.item"
              v-on="couponListeners.bind(item)"
            >
              <div :class="_.content">
                <div :class="_.amount">
                  <div :class="_.unit">¥</div>
                  <div :class="_.value">
                    {{ item.discountedAmt }}
                  </div>
                </div>
                <div :class="[_.desc, _._ellipsis2]">
                  {{ item.minPointAmt }}
                </div>
              </div>
              <div :class="[_.name, _._ellipsis]">{{ item.couponName }}</div>
              <div :class="_.circle" />
              <div
                v-if="item.couponId === couponData.couponId"
                :class="_.check"
              />
            </div>
          </x-horizontal-scroll-view>
          <div v-else :class="_.tips">暂无可用优惠券</div>
        </template>

        <div :class="_.grow"></div>

        <div ref="buy" v-focusable :class="_.button" v-on="buyListeners">
          立即购买
        </div>
      </div>
    </template>
  </tv-page>
</template>

<script>
  import Vue from 'vue'
  import { AddressBridge } from '@/views/address/bridge'
  import {
    apiBasicAddressList,
    apiGroupBuyingTradeCalcPostFee,
    apiGroupBuyingTradePreOrder,
    apiGroupBuyingTradeTradeOrder,
    apiMarketingCouponMyCouponUsableList,
    apiTradeGeneralTradeCalcPostFee,
    apiTradeGeneralTradePreOrder,
    apiTradeGeneralTradeTradeOrder,
    apiTradeSecKillTradeSeckillCalcPostFee,
    apiTradeSecKillTradeSeckillConfirmResult,
    apiTradeSecKillTradeSeckillTradeOrder,
  } from '@/api'
  import { dcb } from '@dcb/jssdk'
  import { defineTvListeners } from '../utils'
  import {
    devOrProd,
    getManyGoodsBonus,
    loopUntil,
    mapQuery,
    onPageVisibilityChange,
    prepareData,
    submit,
    Track,
  } from '@/utils'
  import { flatten, maxBy, sumBy, values, wait } from 'vtils'
  import { globalModel } from '@/model'
  import { handleGoodsError } from '@/views/goods/exports'
  import { mall } from '@/mall_jssdk'
  import { navigateBack, redirectTo } from '@/router'

  const handleGoodsOrderError = handleGoodsError({
    商品下架: () => navigateBack(),
    活动结束: () => navigateBack(),
    活动不能参与: () => navigateBack(),
  })

  export default Vue.extend({
    mixins: [
      globalModel.mixin,
      mapQuery({
        type: {
          key: 'type',
        },
        _preOrderData: {
          key: 'data',
          json: true,
        },
        _preOrderRequestData: {
          key: 'preOrderRequestData',
          json: true,
        },
      }),
      Track.provideMark(() => ({
        page: 'TV-确认订单',
      })),
    ],

    data() {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const ctx = this

      return {
        // 页面级加载状态
        loading: true,

        // 收货地址
        address: {},

        // 下单数据
        orderData: {},

        // 优惠券数据
        couponData: {},

        // 邮费
        postFee: 0,

        // 订单 ID 的邮费
        orderIdToPostFee: {},

        // 最新的预下单数据
        lastPreOrderData: {},

        // 折扣数据
        discountData: [],

        // 全部地址数据
        allAddressData: [],

        // 全部优惠券数据
        allCouponData: [],

        // 跳到商品
        goToGoods: () => {
          ctx.$tv.goTo(ctx.$refs.goods)
        },

        // 跳到收货地址
        goToAddress: index => {
          ctx.$tv.goTo(ctx.$refs.address, index)
        },

        // 跳到优惠券
        goToCoupon: index => {
          ctx.$tv.goTo(ctx.$refs.coupon, index)
        },

        // 跳到购买
        goToBuy: () => {
          ctx.$tv.goTo(ctx.$refs.buy)
        },

        // 商品监听器
        goodsListeners: defineTvListeners(({ type }) => {
          switch (type) {
            case 'right':
              this.goToBuy()
              break
            default:
              break
          }
        }),

        // 地址监听器
        addressListeners: defineTvListeners(({ type, isLast, el, index }) => {
          switch (type) {
            case 'focus':
              ctx.$tv.setScrollEl(ctx.$refs.address)
              break
            case 'blur':
              ctx.$tv.resetScrollEl()
              break
            case 'right':
              if (isLast) {
                ctx.$tv.goTo(el)
              }
              break
            case 'click':
              if (isLast) {
                dcb.navigateTo({
                  url: devOrProd(
                    'https://tv-h5.duotest.cn/app/tv-basic/#/address?isLogin=true',
                    'https://tv-h5.gogpay.cn/tv-basic/#/address?isLogin=true',
                  ),
                })
              } else {
                this.address = this.allAddressData[index]
              }
              break
            default:
              break
          }
        }),

        // 优惠券监听器
        couponListeners: defineTvListeners(({ type, isLast, el, item }) => {
          switch (type) {
            case 'focus':
              ctx.$tv.setScrollEl(ctx.$refs.coupon)
              break
            case 'blur':
              ctx.$tv.resetScrollEl()
              break
            case 'right':
              if (isLast) {
                ctx.$tv.goTo(el)
              }
              break
            case 'click':
              this.couponData = item
              break
            default:
              break
          }
        }),

        // 购买监听器
        buyListeners: defineTvListeners(({ type }) => {
          switch (type) {
            case 'click':
              this.handlePayClick()
              break
            case 'right':
              this.goToBuy()
              break
            default:
              break
          }
        }),
      }
    },

    computed: {
      // 是否拼团下单
      is拼团下单() {
        return this.type === 'groupBuying'
      },
      // 是否秒杀下单
      is秒杀下单() {
        return this.type === 'seckill'
      },
      // 预下单数据
      preOrderData() {
        return this.lastPreOrderData.preOrderId
          ? this.lastPreOrderData
          : this._preOrderData
      },
      // 预下单请求数据
      preOrderRequestData() {
        return this._preOrderRequestData
      },
      // 商品 ID 列表
      goodsIds() {
        return this.preOrderData.orderInfo.reduce((res, merchant) => {
          res.push(...merchant.commodityInfo.map(goods => goods.commodityId))
          return res
        }, [])
      },
      // 商品资源 ID 列表（用于查询优惠券）
      goodsResourceIds() {
        return this.preOrderData.orderInfo.reduce((res, merchant) => {
          res.push(
            ...merchant.commodityInfo.map(goods =>
              JSON.stringify({
                id: goods.resourceId,
                name: goods.commodityName,
                price: goods.unitPrice,
                count: goods.count,
                totalAmt: mall.calculator.sub(
                  goods.totalPrice,
                  goods.discountActivityAmount,
                ),
                superimposeDiscountType: this.discountData[0]?.type || null,
                categoryId: goods.categoryId,
              }),
            ),
          )
          return res
        }, [])
      },
      // 选择优惠券的参数
      pickCouponParams() {
        return {
          goodsIdList: this.goodsResourceIds,
          amt: this.preOrderData.orderAmount,
          discountedAmt: mall.calculator.add(
            ...this.discountData.map(item => item.amount),
          ),
          businessType: this.preOrderData.businessType,
          unitOrgCode: this.preOrderData.unitOrgCode,
        }
      },
      // 商品数量
      totalGoods() {
        return sumBy(
          this.preOrderData.orderInfo,
          merchant => merchant.totalQuantity,
        )
      },
      // 优惠金额
      discountMoney() {
        return mall.calculator.add(
          // 折扣金额
          ...this.discountData.map(item => item.amount),
          // 优惠券金额
          this.is秒杀下单 || this.is拼团下单
            ? 0
            : this.couponData.discountedAmt || 0,
        )
      },
      // 实付金额
      actualMoney() {
        return mall.calculator.add(
          _ =>
            _.sub(
              // 订单金额
              this.preOrderData.orderAmount,
              // 减去优惠金额
              this.discountMoney,
            ),
          // 加上邮费
          this.postFee,
        )
      },
      is全是虚拟商品() {
        return this.preOrderData.preOrderContentType === 2
      },
    },

    watch: {
      // 计算邮费
      address: {
        immediate: true,
        async handler(address) {
          if (!address.id) {
            this.postFee = 0
            this.lastPreOrderData = this._preOrderData
          } else {
            await submit(async $ => {
              await $.start()
              this.lastPreOrderData = await (this.is拼团下单
                ? apiGroupBuyingTradePreOrder({
                    ...this.preOrderRequestData,
                    countyCode: this.address.districtCode,
                  }).catch(handleGoodsOrderError)
                : this.is秒杀下单
                ? // 秒杀商品只预下单一次
                  Promise.resolve(this._preOrderData)
                : apiTradeGeneralTradePreOrder({
                    ...this.preOrderRequestData,
                    countyCode: this.address.districtCode,
                  })
              ).then(async res => {
                const goodsList = flatten(
                  res.orderInfo.map(orderItem => orderItem.commodityInfo),
                )
                const bonusMap = await getManyGoodsBonus(goodsList)
                for (const goods of goodsList) {
                  goods.bonusText = bonusMap[goods.skuId] || ''
                }
                return res
              })
              await wait(0)
              const { orderInfo } = await (this.is拼团下单
                ? apiGroupBuyingTradeCalcPostFee
                : this.is秒杀下单
                ? apiTradeSecKillTradeSeckillCalcPostFee
                : apiTradeGeneralTradeCalcPostFee)({
                preOrderId: this.preOrderData.preOrderId,
                consigneeAddress: {
                  province: this.address.province,
                  city: this.address.city,
                  area: this.address.county,
                  areaCode: this.address.districtCode,
                  detail: this.address.detail,
                  name: this.address.receiver,
                  phoneNo: this.address.phoneNo,
                },
              })
              this.postFee = sumBy(orderInfo, item => item.postFee || 0)
              this.orderIdToPostFee = orderInfo.reduce((res, item) => {
                res[item.orderId] = item.postFee
                return res
              }, {})
            })
          }
        },
      },
      // 计算订单提交数据
      preOrderData: {
        immediate: true,
        handler(preOrderData) {
          this.orderData = preOrderData.orderInfo.reduce((res, merchant) => {
            res[merchant.orderId] = {
              orderId: merchant.orderId,
              remark: '',
            }
            return res
          }, {})
          this.discountData = preOrderData.discountItems || []
        },
      },
    },

    async mounted() {
      await this.prepareData()
      this.goToBuy()
    },

    activated() {
      this._off?.()
      this._off = onPageVisibilityChange(visible => {
        if (visible) {
          this.prepareRequiredData()
        }
      })
    },

    deactivated() {
      this._off?.()
    },

    methods: {
      // 准备数据
      async prepareData() {
        const { address } = await prepareData({
          address: AddressBridge.getDefaultAddress().then(
            res => res || {},
            () => ({}),
          ),
          _: this.prepareRequiredData(),
        })
        this.address = address
        this.loading = false
      },

      // 准备必需的数据
      async prepareRequiredData() {
        const { allAddressData, allCouponData } = await prepareData({
          allAddressData: apiBasicAddressList({}).then(res => res.list),
          allCouponData: apiMarketingCouponMyCouponUsableList(
            this.pickCouponParams,
          ),
        })
        this.allAddressData = allAddressData
        this.allCouponData = allCouponData
        if (
          !this.is秒杀下单 &&
          !this.is拼团下单 &&
          !this.couponData.couponId &&
          this.allCouponData.length
        ) {
          this.couponData = maxBy(
            this.allCouponData,
            item => item.discountedAmt,
          )
        }
      },

      // 点击选择地址
      async handleChooseAddressClick() {
        const address = await AddressBridge.chooseAddress()
        if (address && address.id) {
          this.address = address
        }
      },

      // 点击拼团规则
      handleGroupBuyingRuleClick() {
        dcb.navigateTo({
          url: this.preOrderData.ruleUrl,
        })
      },

      // 点击立即支付按钮
      async handlePayClick() {
        await submit(async $ => {
          if (!this.is全是虚拟商品 && !this.address.id) {
            return $.fail('请先添加收货地址')
          }
          await $.start()
          let payData = await (this.is拼团下单
            ? apiGroupBuyingTradeTradeOrder
            : this.is秒杀下单
            ? apiTradeSecKillTradeSeckillTradeOrder
            : apiTradeGeneralTradeTradeOrder)({
            preOrderId: this.preOrderData.preOrderId,
            consigneeName: this.address.receiver,
            consigneeTel: this.address.phoneNo,
            consigneeAddress: {
              province: this.address.province,
              city: this.address.city,
              area: this.address.county,
              areaCode: this.address.districtCode,
              detail: this.address.detail,
              name: this.address.receiver,
              phoneNo: this.address.phoneNo,
            },
            tradeOrderInfo: values(this.orderData),
            couponId: this.couponData.couponId,
            discountAmount: this.couponData.discountedAmt || 0,
            payType: globalModel.state.payType,
            openId: globalModel.state.openid,
          }).catch(handleGoodsOrderError)
          if (this.is秒杀下单) {
            const res = await loopUntil(
              () => apiTradeSecKillTradeSeckillConfirmResult(),
              res => res.confirmState !== 0,
            )
            if (res.confirmState === 2) return $.fail(res.msg)
            payData = res.result
          }
          try {
            await dcb.requestPayment({
              provider: 'native',
              showNativeResultPage: false,
              params: payData,
            })
            $.fail('支付成功')
            await wait(1000)
            redirectTo('TvOrderIndex')
          } catch {
            $.fail('支付失败')
            await wait(1000)
            redirectTo('TvOrderIndex')
          }
        })
      },
    },
  })
</script>

<style lang="scss" module>
  .page {
    height: 100vh;
    background-color: #1f2733;
    padding: 60px 0 60px 80px;
    display: flex;
  }

  .left {
    position: relative;
    flex-shrink: 0;
    width: 900px;
    height: 100%;
    background: transparent;
    display: flex;
    flex-direction: column;
    --border-radius: 16px;

    .groups {
      flex-grow: 1;
      height: 100%;
      overflow: auto;
      background-color: white;

      .group {
        padding: 0 40px;

        .store {
          display: flex;
          align-items: center;
          padding: 20px 0;

          .icon {
            flex-shrink: 0;
            width: 30px;
            height: 30px;
          }

          .name {
            flex-grow: 1;
            margin-left: 16px;
            font-size: 32px;
            font-weight: 500;
            color: #333333;
            line-height: 46px;
          }
        }

        .list {
          .item {
            display: flex;
            align-items: flex-start;

            .cover {
              flex-shrink: 0;
              width: 230px;
              height: 230px;
              object-fit: cover;
              border-radius: 14px;
            }

            .content {
              margin-left: 20px;
              flex-grow: 1;

              .top {
                display: flex;

                .name {
                  font-size: 36px;
                  font-weight: 500;
                  color: #333333;
                  line-height: 52px;
                }

                .price {
                  font-size: 36px;
                  color: #333333;
                  line-height: 52px;
                }
              }

              .bottom {
                margin-top: 14px;
                display: flex;
                align-items: center;
                font-size: 30px;
                color: #999999;
                line-height: 44px;

                .spec {
                  flex-grow: 1;
                }

                .count {
                  flex-shrink: 0;
                }
              }
            }

            + .item {
              margin-top: 20px;
            }
          }
        }

        .info {
          .item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 20px 0;

            .label {
              font-size: 30px;
              color: #333333;
              line-height: 44px;
            }

            .value {
              font-size: 30px;
              color: #333333;
              line-height: 44px;
            }
          }
        }

        .total {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          font-size: 30px;
          font-weight: 400;
          color: #333333;
          line-height: 44px;
          padding: 20px 0;

          .price {
            font-size: 36px;
            font-weight: 500;
            color: #e0251b;
            line-height: 60px;
          }
        }

        + .group {
          border-top: 10px solid #f5f5f5;
        }
      }
    }

    .summary {
      flex-shrink: 0;
      height: 150px;
      background-color: #faeeee;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      padding: 0 20px;

      .discount {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        font-size: 32px;
        color: #333333;
        line-height: 46px;

        .tips {
          margin-right: 20px;
          font-size: 24px;
          color: rgba(51, 51, 51, 0.6);
        }

        .price {
          color: #e0251b;
        }
      }

      .total {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        font-size: 46px;
        font-weight: 500;
        color: #333333;
        line-height: 66px;

        .price {
          color: #e0251b;
        }
      }
    }

    .bar {
      width: 100%;
      height: 32px;
      margin: -1px 0;
    }
  }

  .right {
    flex-grow: 1;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .title {
      padding-left: 36px;
      font-size: 40px;
      font-weight: 500;
      color: #ffffff;
      line-height: 58px;

      &:not(:first-child) {
        margin-top: 60px;
      }
    }

    .address {
      font-size: 0;
      // 解决 y 轴溢出问题
      // https://stackoverflow.com/a/39554003
      padding: 100px 0;
      margin: -100px 0;
      margin-top: -80px;
      padding-left: 36px;
      padding-right: 40px;

      .item {
        position: relative;
        width: 560px;
        height: 210px;
        background: #ffffff;
        border-radius: 16px;
        --border-radius: 16px;
        padding: 20px;
        box-sizing: border-box;

        .user {
          display: flex;
          align-items: center;
          font-size: 36px;
          font-weight: 500;
          color: #333333;
          line-height: 52px;

          .phone {
            flex-shrink: 0;
            margin-left: 20px;
          }
        }

        .detail {
          margin-top: 20px;
          font-size: 28px;
          color: #666666;
          line-height: 40px;
        }

        .bar {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          height: 18px;
          border-radius: 0 0 16px 16px;
          background-image: url('./images/彩带.png');
          background-repeat: no-repeat;
          background-position: center;
          background-size: cover;
          z-index: 1;
        }

        .check {
          position: absolute;
          bottom: 0;
          right: 0;
          width: 60px;
          height: 60px;
          background-image: url('./images/选中.png');
          background-repeat: no-repeat;
          background-position: center;
          background-size: cover;
          z-index: 2;
        }

        + .item {
          margin-left: 40px;
        }

        &.add {
          display: inline-flex;
          align-items: center;
          justify-content: center;

          .icon {
            width: 60px;
            height: 60px;
            border-radius: 100px;
            border: 1px solid #e1e1e1;
            display: flex;
            align-items: center;
            justify-content: center;

            .image {
              width: 34px;
              height: 34px;
            }
          }

          .label {
            margin-left: 20px;
            font-size: 36px;
            font-weight: 500;
            color: #333333;
          }
        }
      }
    }

    .coupon {
      font-size: 0;
      // 解决 y 轴溢出问题
      // https://stackoverflow.com/a/39554003
      padding: 100px 0;
      margin: -100px 0;
      margin-top: -80px;
      padding-left: 36px;
      padding-right: 40px;

      .item {
        position: relative;
        width: 390px;
        height: 160px;
        background: #fff6ce;
        border-radius: 16px;
        --border-radius: 16px;
        padding: 30px 40px 17px 40px;
        box-sizing: border-box;

        .content {
          display: flex;
          align-items: center;

          .amount {
            display: flex;
            align-items: baseline;

            .unit {
              font-size: 32px;
              color: #e0251b;
              line-height: 46px;
            }

            .value {
              font-size: 60px;
              font-weight: 500;
              color: #e0251b;
              line-height: 50px;
            }
          }

          .desc {
            margin-left: 10px;
            font-size: 26px;
            color: #7d3c1d;
            line-height: 34px;
          }
        }

        .name {
          margin-top: 13px;
          font-size: 32px;
          font-weight: 500;
          color: #7d3c1d;
          line-height: 46px;
        }

        .circle {
          &::before,
          &::after {
            content: '';
            position: absolute;
            display: block;
            width: 30px;
            height: 30px;
            border-radius: 100px;
            background-color: #1f2733;
          }

          &::before {
            left: -15px;
            top: 50%;
            transform: translateY(-50%);
          }

          &::after {
            right: -15px;
            top: 50%;
            transform: translateY(-50%);
          }
        }

        .check {
          position: absolute;
          bottom: 0;
          right: 0;
          width: 60px;
          height: 60px;
          background-image: url('./images/选中.png');
          background-repeat: no-repeat;
          background-position: center;
          background-size: cover;
          z-index: 2;
        }

        + .item {
          margin-left: 40px;
        }
      }
    }

    .tips {
      margin-top: 20px;
      padding-left: 36px;
      font-size: 30px;
      color: rgba(255, 255, 255, 0.6);
      line-height: 44px;
    }

    .grow {
      flex-grow: 1;
    }

    .button {
      margin: 36px;
      height: 120px;
      border-radius: 100px;
      --border-radius: 100px;
      border: 2px solid #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 50px;
      color: #ffffff;
      box-sizing: border-box;

      &[focused] {
        background: linear-gradient(141deg, #ff5f33 0%, #ef1325 100%);
        color: white;
        border: none;
      }
    }
  }
</style>
